var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterAltMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_380_1978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_380_1978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 20.8346C11.1632 20.8346 10.9158 20.7348 10.7161 20.5352C10.5165 20.3355 10.4166 20.0881 10.4166 19.793V13.543L4.37498 5.83464C4.11457 5.48741 4.0755 5.12283 4.25779 4.74089C4.44009 4.35894 4.75693 4.16797 5.20832 4.16797H19.7916C20.243 4.16797 20.5599 4.35894 20.7422 4.74089C20.9245 5.12283 20.8854 5.48741 20.625 5.83464L14.5833 13.543V19.793C14.5833 20.0881 14.4835 20.3355 14.2838 20.5352C14.0842 20.7348 13.8368 20.8346 13.5416 20.8346H11.4583ZM12.5 12.8138L17.6562 6.2513H7.34373L12.5 12.8138Z",
    fill: "#A0A0A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAltMob);
export default __webpack_public_path__ + "static/media/filter_alt_mob.2aea59dfd31b1048100b9ba7304d296a.svg";
export { ForwardRef as ReactComponent };